import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="dark-gradient text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Product Range */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Product Range</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Continuous Hardening</li>
              <li>Retort Furnaces</li>
              <li>Salt Bath Furnaces</li>
              <li>Annealing Furnaces</li>
            </ul>
          </div>

          {/* Get In Touch */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Get In Touch</h4>
            <address className="text-gray-300 not-italic">
              173- Mehta Road,<br />
              Focal Point,Industrial Area,Amritsar - 143006,<br />
              Punjab (India)<br /><br />
              Phone: +91 62390 19768<br />
              Email:{' '}
              <a
                href="mailto:rkkohli.sons@gmail.com"
                className="text-yellow-400 hover:underline"
              >
                  rkkohli.sons@gmail.com
              </a>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2025 Arkotherm Furnaces · All rights reserved
          </div>
          <div className="text-gray-500 text-sm mt-2 md:mt-0">
            Designed by Arkotherm
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;